import React, { useState, useEffect, useRef } from "react";
import sendBtn from "../../images/sendBtn.png";
import TableHead from "../TableHead";
import axios from "axios";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import styles from "./Table.module.css";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { ListItemIcon } from "@mui/material";
import Select from "react-select";
import { display, height, padding } from "@mui/system";
import { useSidebarContext } from "../Sidebar/context/SidebarState";
import { FaFileExport } from "react-icons/fa6";
import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";

const Table2 = ({
  tableData,
  headings,
  userId,
  onRowClick,
  setTableData,
  setDistributorNameInput,
  setSelectedFile,
  setFundNameInput,
  handleDownloadFile,
  setSelectedRowIds,
  selectedRowIds,
  curStatus,
  setCurStatus,
  statusArray = [],
  currentPage,
  setCurrentPage,
  rowsPerPage,
  setRowsPerPage,
  totalPages: totalPages1,
  filter: distributorFilterValue,
  setFilter: setDistributorFilterValue,
}) => {
  console.log(totalPages1, "pages");
  console.log(tableData, "tableData");

  const { isMoreSidebar } = useSidebarContext();

  const tableRef = useRef(null);
  const [remarks, setRemarks] = useState("");
  const [file, setFile] = useState(null);
  const [selectedRows, setSelectedRows] = useState([]);
  // const [distributorFilterValue, setDistributorFilterValue] = useState("");
  const [fundFilterValue, setFundFilterValue] = useState("");
  const [statusFilterValue, setStatusFilterValue] = useState("");
  // const [currentPage, setCurrentPage] = useState(1);
  // const [rowsPerPage, setRowsPerPage] = useState(10);
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [isFocused, setIsFocused] = useState(false);


  useEffect(() => {
    if (curStatus === "Exceeding 2 days" || curStatus === "Exceeding 3 days") {
      setDistributorFilterValue(curStatus);
    } else if (curStatus || curStatus === "") {
      setSelectedStatus({ value: curStatus, label: curStatus });
    }
  }, [curStatus]);

  const toggleRowSelection = (rowData) => {
    const updatedTableData = tableData.map((row) => {
      if (row.id === rowData.id) {
        return {
          ...row,
          isSelected: !row.isSelected,
        };
      }
      return row;
    });

    setTableData(updatedTableData);

    const selectedIndex = selectedRows.findIndex(
      (row) => row.id === rowData.id
    );
    if (selectedIndex === -1) {
      setSelectedRows([...selectedRows, { ...rowData, isSelected: true }]);
    } else {
      const updatedRows = [...selectedRows];
      updatedRows.splice(selectedIndex, 1);
      setSelectedRows(updatedRows);
    }
  };

  const handleSelectAll = (event) => {
    const updatedTableData = tableData.map((row) => ({
      ...row,
      isSelected: event.target.checked,
    }));

    setTableData(updatedTableData);

    if (event.target.checked) {
      const selectedRows = tableData.map((row) => ({
        ...row,
        isSelected: true,
      }));
      setSelectedRows(selectedRows);
    } else {
      setSelectedRows([]);
    }
  };

  const handleRowClick = (rowData) => {
    onRowClick(rowData);
  };

  const handleDump = async () => {
    if (selectedRows.length === 0) {
      alert("No rows selected to dump");
      return;
    }
    alert("Dumped to excel");

    const headerRow = [
      "Id",
      "Distributor Name",
      "Fund Name",
      "Invoice Month",
      "Gst Category",
      "Tds Category",
      "Fee Type",
      "Brokerage Amount",
      "Brokerage Calculation File",
      "Invoice File",
      "Status",
    ];

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Sheet 1");

    const headerRowExcel = worksheet.addRow(headerRow);

    headerRowExcel.eachCell((cell, colNumber) => {
      cell.font = { bold: true };
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "FFFF00" },
      };
    });

    selectedRows.forEach((rowData) => {
      const FeeTypes = rowData.feeTypeCode.map((item) => item || "").join(", ");

      const rowValues = [
        rowData.id || "",
        rowData.distributorName || "",
        rowData.fundName || "",
        rowData.invoiceMonth || "",
        rowData.gstCategoryCode || rowData.gstCategory || "",
        rowData.tdcCategoryCode || rowData.tdsCategory || "",
        FeeTypes || "",
        rowData.totalAmount || "",
        rowData.brokerageFileRow
          ? rowData.brokerageFileRow.folderPath
          : rowData.brokerageFile || "",
        rowData.invoiceFileRow
          ? rowData.invoiceFileRow.folderPath
          : rowData.invoiceFile || "",
        rowData.statusName || "",
      ];
      worksheet.addRow(rowValues);
    });

    worksheet.columns = [
      { key: "Id", width: 10 },
      { key: "Distributor Name", width: 25 },
      { key: "Fund Name", width: 30 },
      { key: "Invoice Month", width: 15 },
      { key: "GST Category", width: 10 },
      { key: "TDS Category", width: 10 },
      { key: "Fee Type", width: 20 },
      { key: "Brokerage Amount", width: 10 },
      { key: "Brokerage File", width: 30 },
      { key: "Invoice File", width: 30 },
      { key: "Status", width: 10 },
    ];

    worksheet.columns.forEach((column) => {
      column.alignment = { wrapText: true };
    });

    worksheet.eachRow((row, rowNumber) => {
      let maxHeight = 15;
      row.eachCell((cell) => {
        const lines = cell.value.toString().split("\n").length;
        if (lines > 1) {
          maxHeight = Math.max(maxHeight, lines * 15);
        }
      });
      row.height = maxHeight;
    });

    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = "selected_table_data.xlsx";

    link.click();
  };

  // const filteredTableData = tableData.filter((row) => {
  //   const distributorFilterValueLower = distributorFilterValue.toLowerCase();

  //   const matchesDistributorFilter = Object.values(row).some((value) => {
  //     if (value === null || value === undefined) {
  //       return false;
  //     } else if (typeof value === "string") {
  //       return value.toLowerCase().includes(distributorFilterValueLower);
  //     } else if (typeof value === "number") {
  //       return value.toString().includes(distributorFilterValue);
  //     } else if (typeof value === "boolean") {
  //       return value.toString().includes(distributorFilterValue);
  //     } else if (Array.isArray(value)) {
  //       return value.some((item) =>
  //         item.toString().toLowerCase().includes(distributorFilterValueLower)
  //       );
  //     } else {
  //       return false;
  //     }
  //   });

  //   const matchesStatusFilter =
  //     selectedStatus === null ||
  //     selectedStatus.value === "all" ||
  //     row.statusName.toLowerCase().includes(selectedStatus.value.toLowerCase());

  //   if (distributorFilterValueLower === "exceeding 2 days") {
  //     return row.TAT === "red" && matchesStatusFilter;
  //   } else if (distributorFilterValueLower === "all") {
  //     return true;
  //   }

  //   return matchesDistributorFilter && matchesStatusFilter;
  // });

  useEffect(() => {
    setCurrentPage(1);
  }, [distributorFilterValue, selectedStatus]);

  // const indexOfLastRow = currentPage * rowsPerPage;
  // const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  // const currentRows = filteredTableData.slice(indexOfFirstRow, indexOfLastRow);

  const totalPages = Math.ceil(totalPages1 / rowsPerPage);

  const handleChangePage = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleChangeRowsPerPage = (e) => {
    setRowsPerPage(parseInt(e.target.value, 10));
    setCurrentPage(1);
  };

  const iconStyles = {
    listItemIcon: {
      height: "35px",
      width: "35px !important",
      backgroundColor: "#66615b",
      borderRadius: "50%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      padding: "0px",
    },
    icon: {
      color: "#009ef7",
      cursor: "pointer",
      "&:hover": {
        color: "black",
      },
    },
  };

  const statusOptions = [
    // { value: "all", label: "All" },
    ...statusArray.map((status) => ({
      value: status.statusName,
      label: status.statusName,
    })),
  ];

  const customStyles = {
    container: (provided) => ({
      ...provided,
      width: "300px",
      margin: "10px 0",
      // marginLeft: '20px'
    }),
    control: (provided) => ({
      ...provided,
      maxHeight: "50px",
    }),
    valueContainer: (provided) => ({
      ...provided,
      // display: 'flex',
      // alignItems: 'center',
      height: "50px", // Ensure this matches the control height
      // padding:"8px 2px"
    }),
  };

  // const handleSelectStatus = (e) => {
  //   console.log(e.value, 'e')
  //   debugger
  //   setSelectedStatus(e.value);
  //   if (e.value) {
  //     setCurStatus(e.value);
  //     console.log(e.value, "selected status");
  //   } else {
  //     setCurStatus("");
  //     console.log("Selection cleared");
  //   }
  // };
  const handleSelectStatus = (e) => {
    console.log(e.value);
    debugger
    setSelectedStatus(e.value);
    setCurStatus(e?.value || "");
  };

  console.log('selectedStatus',selectedStatus)

  return (
    <div
      className={
        isMoreSidebar
          ? styles.distributorMasterTable
          : styles.distributorMasterTable1
      }
      ref={tableRef}
    >
      {/* {tableData.length > 0 && ( */}
      <>
        <div className={styles.tableHeader}>
          <div className={styles.tableHeaderLeft}>
            <span className={styles.tableTitle}>Distributor List</span>
            <div className="filter-main">
              {/* <input
                type="text"
                placeholder="Search"
                value={distributorFilterValue}
                onChange={(e) => setDistributorFilterValue(e.target.value)}
                className={styles.filterInput}
              /> */}
              <InputText
                type="text"
                placeholder="Search"
                value={distributorFilterValue}
                onChange={(e) => setDistributorFilterValue(e.target.value)}
                style={{
                  border: "2px solid #c4d0ff", // Change border dynamically
                  borderRadius: "4px",
                  padding: "0px 4px",
                }}
              />
              {/* <Select
                  styles={customStyles}
                  value={selectedStatus}
                  onChange={handleSelectStatus}
                  options={statusOptions}
                  placeholder="Filter by status"
                  isClearable
                  isMulti={false}
                /> */}  
              
              <Dropdown
                value={selectedStatus?.value}
                onChange={handleSelectStatus}
                options={statusOptions}
                placeholder="Filter by status"
                onFocus={() => setIsFocused(true)}
                onBlur={() => setIsFocused(false)} 
                
                style={{
                  border: isFocused ? "2px solid #009ef7 !important" : "2px solid #c4d0ff", // Change border dynamically
                  borderRadius: "4px",
                  padding: "5px 5px",
                }}
              />
            </div>
          </div>
          <span className={styles.tableAction}>
            {/* <img
                className={styles.sendButton}
                src={sendBtn}
                alt=""
                id="dump"
                onClick={handleDump}
                title="Dump to excel"
              /> */}
            <FaFileExport className="w-6 h-6" style={{ color: "#912FBD" }} onClick={handleDump}/>
          </span>
        </div>
        <div className={styles.tableContainer}>
          {tableData.length > 0 ? (
            <table id="Mytable">
              <TableHead headings={headings} onSelectAll={handleSelectAll} />
              <tbody>
                {tableData.map((item) => (
                  <tr
                    key={item.id}
                    onClick={() => handleRowClick(item)}
                    className={`${styles.tableRow} ${
                      selectedRowIds.includes(item.id)
                        ? styles.rowSelected
                        : item.TAT === "red"
                        ? styles.rowRejected
                        : ""
                    }`}
                  >
                    <td>
                      <input
                        type="checkbox"
                        onChange={() => toggleRowSelection(item)}
                        checked={selectedRows.some((row) => row.id === item.id)}
                      />
                    </td>
                    <td>{item.id}</td>
                    <td>{item.distributorName}</td>
                    <td>{item.fundName}</td>
                    <td>{item.invoiceMonth}</td>
                    <td>{item.gstCategoryCode || item.gstCategory}</td>
                    <td>{item.tdcCategoryCode || item.tdsCategory}</td>
                    <td>
                      {(item.feeTypeCode && item.feeTypeCode.join(", ")) ||
                        item.feeType.join(", ")}
                    </td>
                    <td>{item.totalAmount}</td>
                    <td
                      className={styles.downloadLink}
                      onClick={() =>
                        handleDownloadFile(
                          item.brokerageFile
                            ? item.brokerageFile
                            : item.brokerageFileRow
                            ? item.brokerageFileRow.folderPath
                            : ""
                        )
                      }
                    >
                      {item.brokerageFile ||
                      (item.brokerageFileRow &&
                        item.brokerageFileRow.folderPath) ? (
                        <span>
                          <ListItemIcon>
                            <FileDownloadIcon style={iconStyles.icon} />
                          </ListItemIcon>
                        </span>
                      ) : (
                        ""
                      )}
                    </td>
                    <td
                      className={styles.downloadLink}
                      onClick={() =>
                        handleDownloadFile(
                          item.invoiceFileRow
                            ? item.invoiceFileRow.folderPath
                            : item.invoiceFile
                        )
                      }
                    >
                      {(item.invoiceFileRow &&
                        item.invoiceFileRow.folderPath) ||
                      item.invoiceFile ? (
                        <span>
                          <ListItemIcon>
                            <FileDownloadIcon style={iconStyles.icon} />
                          </ListItemIcon>
                        </span>
                      ) : (
                        ""
                      )}
                    </td>
                    <td>{item.statusName}</td>
                    <td>{item.utrnumber}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <div className={styles.noDataFound}>No Data Found</div>
          )}
        </div>
        <div className={styles.pagination}>
          <span className={styles.rowsVisible}>
            <select
              value={rowsPerPage}
              onChange={handleChangeRowsPerPage}
              className={styles.rowsPerPageSelect}
            >
              <option value={5}>5</option>
              <option value={10}>10</option>
              <option value={20}>20</option>
              <option value={50}>50</option>
            </select>
            rows visible
          </span>
          <div>
            <span>
              <button
                className={styles.pageButton}
                onClick={() => handleChangePage(1)}
                disabled={currentPage === 1}
              >
                &laquo;
              </button>
              <button
                className={styles.pageButton}
                onClick={() => handleChangePage(currentPage - 1)}
                disabled={currentPage === 1}
              >
                &lsaquo;
              </button>
            </span>
            {[...Array(totalPages)].map((_, index) => (
              <button
                key={index + 1}
                className={`${styles.pageButton} ${
                  currentPage === index + 1 ? styles.currentPage : ""
                }`}
                onClick={() => handleChangePage(index + 1)}
              >
                {index + 1}
              </button>
            ))}
            <span>
              <button
                className={styles.pageButton}
                onClick={() => handleChangePage(currentPage + 1)}
                disabled={currentPage === totalPages}
              >
                &rsaquo;
              </button>
              <button
                className={styles.pageButton}
                onClick={() => handleChangePage(totalPages)}
                disabled={currentPage === totalPages}
              >
                &raquo;
              </button>
            </span>
          </div>
        </div>
      </>
      {/* )} */}
    </div>
  );
};

export default Table2;
